<!-- 会话总览 -->
<template>
  <div class="hello">
    <div style="width: 100%; height: 100%">
      <div class="overview">
        <div class="overview_nav">
          <div class="time-box">
            <el-button
              @click="timeee()"
              style="margin-left:.0rem;border: .0rem;"
              :class="adc == true ? 'xiansl' : 'yincl'"
              >24小时</el-button
            >
            <el-button
              @click="time_tim()"
              style="margin-left: 0;
    border: .0rem;
    padding: .5rem 2.0rem !important;
    border-radius: 0;
    border-right: .1rem #E9F0EB solid;
    border-left: .1rem #E9F0EB solid;"
              :class="ap == true ? 'xiansl' : 'yincl'"
              ><span class="btn-span">近7天</span></el-button
            >
            <el-button
              @click="time_im()"
              style="margin-left:.0rem;border: .0rem;"
              :class="ad == true ? 'xiansl' : 'yincl'"
              >近30天</el-button
            >
          </div>
          <span>
            <el-date-picker
              v-model="value3"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="search_a"
            ></el-date-picker>
          </span>
          <span>
            <el-select
              style="width: 26.0rem; min-width: auto"
              clearable
              v-model="value_xiala"
              placeholder="消息类型"
              @change="search_a"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </span>
          <span>
            <el-input
              clearable
              placeholder="请输入内容"
              prefix-icon="el-icon-search"
              v-model="content_mone"
              style="width: 35.0rem; "
              @change="search_a()"
            >
            <el-button slot="append" type="primary" class="btn-chaxun"  @click="search_a()"
              >查询</el-button
            >
            </el-input>

          </span>
        </div>
        <div class="overview_body">
          <div style="margin-top: 2.0rem">
            <el-table
              :data="tableData_z"

              style="width: 100%"
              border

            >
              <el-table-column
                prop="from"
                label="发送方"
                style="width: 10%"
              ></el-table-column>
              <el-table-column
                prop="tolist"
                label="接收方"
                style="width: 10%"
              ></el-table-column>
              <el-table-column
                prop="chatrecord_title"
                label="聊天标题"
                style="width: 10%"
              >
              </el-table-column>
              <el-table-column
                prop="content"
                label="发送内容"
                style="width: 20%"
              >
              <template slot-scope="scope">
                <span class="content" :title="scope.row.content">{{ scope.row.content }}</span>
              </template>
            </el-table-column>

              <el-table-column prop="msgtype" label="类型" style="width: 10%">
                <template slot-scope="scope">
                  <div v-if="scope.row.msgtype == 'text'" class="leix">
                    <img
                      src="../../assets/cb7593481ac1e2e7d326dc52f00ca22.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;文本消息</span>
                  </div>
                  <div v-else-if="scope.row.msgtype == 'mixed'" class="leix">
                    <img
                      src="../../assets/51d0274e4c9895dce263a37a83c5b31.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;混合消息</span>
                  </div>
                  <div
                    v-else-if="scope.row.msgtype == 'chatrecord'"
                    class="leix"
                  >
                    <img
                      src="../../assets/4657daa2aa33a1a1f3114d6852bff46.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;会话记录</span>
                  </div>
                  <div v-else-if="scope.row.msgtype == 'todo'" class="leix">
                    <img
                      src="../../assets/3f5c16da9a2a30ba3d7192eb8c6640f.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;代办记录</span>
                  </div>
                  <div v-else-if="scope.row.msgtype == 'docmsg'" class="leix">
                    <img
                      src="../../assets/504c15917ed07a1f2b824d5fc6c44d5.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;在线文档</span>
                  </div>
                  <div v-else-if="scope.row.msgtype == 'meeting'" class="leix">
                    <img
                      src="../../assets/8a98fd465119872186d1d6b651a4481.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;会议邀请</span>
                  </div>
                  <div
                    v-else-if="scope.row.msgtype == 'redpacket'"
                    class="leix"
                  >
                    <img
                      src="../../assets/b927049ac34dd69992d6220fdb71201.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;红包记录</span>
                  </div>
                  <div v-else-if="scope.row.msgtype == 'image'" class="leix">
                    <img
                      src="../../assets/faa2e723d30c383e191028f57c75ea8.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;图片&#12288;&#12288;</span>
                  </div>
                  <div v-else-if="scope.row.msgtype == 'video'" class="leix">
                    <img
                      src="../../assets/b54ed789c0b61d2a7cf15e479044ffa.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;视频&#12288;&#12288;</span>
                  </div>
                  <div v-else-if="scope.row.msgtype == 'weapp'" class="leix">
                    <img
                      src="../../assets/ce18abd8225965e57ee4bc7f03529e7.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;小程序&#12288;</span>
                  </div>
                  <div v-else-if="scope.row.msgtype == 'location'" class="leix">
                    <img
                      src="../../assets/c4fe4ab0953c0f5fe4d42e9ce25d7c7.png"
                      alt
                      style="position: relative; top: .5rem"
                    />
                    <span>&nbsp;位置&#12288;&#12288;</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="filesize"
                label="大小/B"
                style="width: 10%"
              >
              </el-table-column>
              <el-table-column
                prop="msgtime"
                label="发送时间"
                style="width: 20%"
              >
                <template slot-scope="scope">
                  <div>{{ (scope.row.msgtime * 1000) | formatDate }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="paging">
            <pagination
              :total="total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              :auto-scroll="false"
              @pagination="load"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "pandect",
  data() {
    return {
      title: [],
      tooken: "",
      // options: [
      //   {
      //     value: "text",
      //     label: "文本消息",
      //   },
      //   {
      //     value: "mixed",
      //     label: "混合消息",
      //   },
      //   {
      //     value: "chatrecord",
      //     label: "会话记录",
      //   },
      //   {
      //     value: "todo",
      //     label: "代办消息",
      //   },
      //   {
      //     value: "docmsg",
      //     label: "在线文档",
      //   },
      //   {
      //     value: "meeting",
      //     label: "会议邀请",
      //   },
      //   {
      //     value: "redpacket",
      //     label: "红包消息",
      //   },
      //   {
      //     value: "image",
      //     label: "图片",
      //   },
      //   {
      //     value: "video",
      //     label: "视频",
      //   },
      //   {
      //     value: "weapp",
      //     label: "小程序",
      //   },
      //   {
      //     value: "location",
      //     label: "位置",
      //   },
      // ], //消息类型
      value_xiala: "", //通过消息类型id来搜索
      tableData_z: [], // 会话总览渲染
      time: "", //时间 /天
      value1: [],
      value2: [],
      value3: [],
      content_mone: "",
      options: [
        {
          value: "text",
          label: "文本消息",
        },
        {
          value: "mixed",
          label: "混合消息",
        },
        {
          value: "chatrecord",
          label: "会话记录",
        },
        {
          value: "todo",
          label: "代办消息",
        },
        {
          value: "docmsg",
          label: "在线文档",
        },
        {
          value: "meeting",
          label: "会议邀请",
        },
        {
          value: "redpacket",
          label: "红包消息",
        },
        {
          value: "image",
          label: "图片",
        },
        {
          value: "video",
          label: "视频",
        },
        {
          value: "weapp",
          label: "小程序",
        },
        {
          value: "location",
          label: "位置",
        },
      ],
      adc: false,
      ap: false,
      ad: false,
      yeshu: 1,
      kaissj: "",
      listQuery: {
        page: 1,
        limit: 10,
      },
      total: "",
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   // // console.log(userinfo);
    //   this.title = title;
    //   // // console.log(this.title);
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    //   // // console.log(this.username);
    // }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      // // console.log(userinfo);
      this.tooken = userinfo;
    }
    this.pandecto();
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  methods: {
    //会话总览 显示隐藏
    pandecto() {
      this.yeshu = 1;
      //获取会话总览列表
      this.axios
        .post(
          "/home/sessionUser/sessionTotalRecord",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_z = res.data.data;
          this.total = res.data.count;
        })
        .catch(function (err) {});
    },
    //会话总览筛选
    search_a() {
      this.yeshu = 1;
      let a = "";
      let b = "";
      if (Array.isArray(this.value3)) {
        b = new Date(this.value3[0]).getTime();
        a = new Date(this.value3[1]).getTime();
        b = (b * 1) / 1000;
        a = (a * 1) / 1000;
      }

      this.kaissj = b;
      this.jssj = a;
      this.axios
        .post(
          "/home/sessionUser/sessionTotalRecord",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            time: this.time,
            start_time: b,
            end_time: a,
            msgtype: this.value_xiala,
            content: this.content_mone,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_z = res.data.data;
          this.total = res.data.count;
        })
        .catch(function (err) {});
    },
    timeee() {
      this.time = 1;
      this.adc = true;
      this.ap = false;
      this.ad = false;
      // console.log(this.adc);
      // console.log(this.ap);
      // console.log(this.ad);
      this.search_a();
    },
    time_tim() {
      this.time = 7;
      this.adc = false;
      this.ap = true;
      this.ad = false;
      // console.log(this.adc);
      // console.log(this.ap);
      // console.log(this.ad);
      this.search_a();
    },
    time_im() {
      this.time = 30;
      this.adc = false;
      this.ap = false;
      this.ad = true;
      // // console.log(this.adc);
      // // console.log(this.ap);
      // // console.log(this.ad);
      this.search_a();
    },
    load() {
      this.yeshu += 1;
      this.axios
        .post(
          "/home/sessionUser/sessionTotalRecord",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            phone: this.tooken.phone,
            time: this.time,
            start_time: this.kaissj,
            end_time: this.jssj,
            msgtype: this.value_xiala,
            content: this.content_mone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_z = res.data.data;
          this.total = res.data.count;
        })
        .catch(function (err) {
          // // console.log(err); 14 16
        });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__body tr.current-row > td {
  background-color: rgb(185, 234, 250);
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgb(185, 234, 250);
}
::v-deep
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td {
  background-color: rgb(185, 234, 250);
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}
.wei_body {
  margin-top: 4.2rem;
  width: 167.1rem;
  height: 94.2rem;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 2.6rem;
  /* margin-bottom: 4.0rem; */
}
.a {
  background-color: #2890dd;
  color: #ffffff;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}

.show {
  display: inline-block;
}
.conceal {
  display: none;
}
.staffo_home {
  width: 100%;
  height: 100%;
  /* background-color: red; */
  /* border: .2rem solid rgba(210,210,210,1); */
}


.staffo_home_nav {
  color: #fff;
  padding: 2.0rem;
  min-height: 4.3rem;
  display: inline-flex;
  align-items: center;
  color: #19273c;
  font-size: 1.8rem;
  font-weight: 500;
  color: #333333;
  line-height: 2.5rem;
  padding: 2.0rem;
}
.staffo_home_nav > span {
  font-size: 2.2rem;
}
.staffo_home_body {
  width: 100%;
  height: 66.2rem;
  background: rgba(251, 251, 251, 1);
  overflow: hidden;
  overflow-y: auto;
}
.select {
  width: 100%;
  height: 4.0rem;
  /* background-color: red; */
  margin-top: 4.0rem;
  display: flex;
  justify-content: space-around;
}
.select > span {
  /* font-weight: 100; */

  cursor: pointer;
  /* margin-left: 3.0rem; */
}
.select > span:hover {
  color: #3088db;
}
.gain {
  color: #3088db;
}
.no_gain {
  color: #4c4c4c;
}
.staff {
  width: 100%;
  height: 4.0rem;
  margin-top: 2.0rem;
  display: flex;
  justify-content: space-around;
}
.staff > span {
  cursor: pointer;
}
.staff > span:hover {
  color: #3088db;
}
.overview {
  width: 100%;
  height: 100% !important;

}
.overview_nav {
  width: 100%;

}
.overview_nav > span {
  margin-right: 2.0rem;
}
.overview_body {
  width: 100%;
}
.leix > span {
  position: relative;
  bottom: .2rem;
}
.el-tree-node__content {
  width: 100%;
}
.interior {
  margin-top: 3.0rem;
  display: inline-block;
  float: left;
  width: 100%;
}
.staffo_home_body_section {
  display: flex;
  justify-content: space-around;
  margin-top: 4.0rem;
}
.chatting_records {
  width: 90%;
  margin-top: 2.0rem;
  margin-left: 5%;

}
.chatting_records_fasong {
  /* float: left; */
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-top: 1.0rem;
  margin-bottom: 1.0rem;
  justify-content: flex-end;
}
.touxiang {
  width: 5.0rem;
  height: 5.0rem;
}
.information {
  display: inline-block;
  max-width: 70%;
  margin-right: 1.0rem;
  position: relative;
  bottom: 1.0rem;
}
.information_name {
  margin-bottom: .5rem;
  /* margin-left: .5rem; */
  text-align: right;
  color: #999999;
}
.conversation_body {
  box-shadow: .0rem .1rem .3rem .0rem rgba(167, 167, 167, 0.2);
  padding: 1.0rem;
  border-radius: .3rem;
  min-height: 2rem;
  background-color: rgba(255, 255, 255);
}
.name_docmsg {
  width: 30.0rem;
  height: 10.0rem;
  /* background-color: red; */
  color: black;
}
.name_docmsg_name {
  width: 18.0rem;
  height: 3em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  top: 2.0rem;
}
.name_docmsg_haha {
  font-size: 1.6rem;
  color: rgb(181, 181, 181);
  margin-top: 2.0rem;
}
/* 文档在线文档 */
.abc {
  display: inline-block;
}
.name_docmsg > img {
  margin-left: 4.0rem;
  margin-bottom: 2.5rem;
}
/* 直播css */
.link_zhibo {
  width: 30.0rem;
  height: 10.0rem;
  /* background-color: red;  */
}
.link_imges {
  width: 100%;
  height: 4.0rem;
  /* background-color: yellow; */
}
.link_imges > img {
  width: 3.0rem;
  height: 3.0rem;
  border-radius: 50%;
}
.link_imges > span {
  font-size: 1.6rem;
  color: rgb(181, 181, 181);
  position: relative;
  left: 1.0rem;
  top: -.8rem;
}
.link_biaoti {
  margin-top: 1.0rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 小程序 */
.weapp_body {
  width: 30.0rem;
  /* height: 40.0rem; */
  /* background-color: red; */
}
.weapp_nav {
  width: 30.0rem;
  height: 5.0rem;
  /* background-color: yellow; */
  z-index: 10;
}
.weapp_imgs {
  width: 30.0rem;
  /* height: 30.0rem; */
  /* background-color: rebeccapurple; */
}
.weapp_bottom {
  width: 30.0rem;
  /* height: 5.0rem; */
  /* background-color: black; */
}
.weapp_img {
  display: inline-block;
  width: 3.0rem;
  height: 3.0rem;
  position: relative;
  left: 1.0rem;
  top: 1.0rem;
  /* background-color: blue; */
  z-index: 1000;
}
.weapp_text {
  display: inline-block;
  position: relative;
  left: 2.0rem;
  top: .0rem;
  color: #999999;
  font-size: 1.6rem;
}
.weapp_imgs_text {
  width: 30.0rem;
  /* height: 10.0rem; */
  /* background-color: yellow; */
  padding-bottom: 1.0rem;
}
.weapp_imgs_img {
  width: 30.0rem;
  /* height: 25.0rem; */
  /* background-color: aqua; */
  padding-bottom: 1.5rem;
  /* background-color: rgb(245, 249, 252); */
}
.weapp_bottom {
  padding: 1.2rem;
  border-top: .1rem solid rgb(230, 230, 230);
  padding-bottom: 0;
}
.weapp_bottom > img {
  width: 2.0rem;
  height: 2.0rem;
}
.weapp_bottom > span {
  position: relative;
  font-size: 1.6rem;
  color: #999999;
  left: 1.0rem;
  bottom: .3rem;
}
.xiansl {
  color:#49B372 !important;
  
}
::v-deep .el-button:hover{
  border-color: #E9F0EB ;
}
.yincl {
  background-color: #ffffff;
  color: black;
}
/*字体长度限制*/
.content{
  display: inline-block;
  width: 15.0rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/**/
.time-box{
  display: inline-block;border: .1rem solid #E9F0EB;
  border-radius: .6rem;
  background: #FCFFFB;
  margin-right: 2.0rem;
}

.el-button{
  background: #FCFFFB;
}
.el-range-editor.el-input__inner{
  width: 50.0rem;
height: 4.0rem;
background: #FFFFFF;
border-radius: .8rem;
border: .1rem solid #E6E6E6;
}
.el-input--suffix .el-input__inner{
  width: 26.0rem;
height: 4.0rem;
background: #FFFFFF;
border-radius: .8rem;
border: .1rem solid #E6E6E6;
}
.btn-chaxun{
  float: right;
  width: 8.0rem;
height: 4.0rem;
background: #49B372;
border-radius: .8rem;
font-size: 1.4rem;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;

}
hr{
width: 95%;
background: #E6E6E6;
border: .1rem solid #E6E6E6;
margin: auto;
}
.el-table thead th,
.el-table th,
.el-table tr {
  background-color:#FDFEFD !important ;
}
.pagination-container{
  background: none;
}
::v-deep .el-button:focus,.el-button:hover{
  color: #49B372;
  background-color:#FDFEFD;
}
</style>
